/**
 * Pure reads over `state.ollie.findings` for the panel, feature pages
 * ("Ollie noticed"), the Ollie button dot and Success Hub rows.
 */

export const selectOllieFindingsState = state => state?.ollie?.findings || null

export const isOllieFindingsForVenue = (findings, venueId) =>
  Boolean(venueId) &&
  findings?.venueId === String(venueId) &&
  findings.status === 'ready'

/** What is on screen: Express ranks, at most `maxVisible` (3). */
export const listVisibleOllieFindings = (findings, venueId) => {
  if (!isOllieFindingsForVenue(findings, venueId)) return []
  return (findings.items || []).slice(0, findings.maxVisible || 3)
}

/** A feature page's findings, in Express rank order. */
export const listOllieFindingsForChecks = (
  findings,
  venueId,
  checkIds = [],
) => {
  if (!isOllieFindingsForVenue(findings, venueId)) return []
  const wanted = new Set(checkIds)
  return (findings.items || []).filter(item => wanted.has(item.checkId))
}

/**
 * Items this person hasn't been shown yet (Express `newForYou`). Older
 * payloads without it fall back to new-this-run / back with new items.
 */
export const isOllieFindingNewForYou = item =>
  typeof item?.newForYou === 'boolean'
    ? item.newForYou
    : Boolean(item?.newSinceLastRun || item?.reopenedWithNewEvidence)

export const listNewOllieFindings = (findings, venueId) =>
  listVisibleOllieFindings(findings, venueId).filter(
    item => item.kind !== 'notice' && isOllieFindingNewForYou(item),
  )

export const findOllieFinding = (findings, venueId, checkId) =>
  isOllieFindingsForVenue(findings, venueId)
    ? (findings.items || []).find(item => item.checkId === checkId) || null
    : null
